import { createContext, useContext } from "react";

export type ContextProps = {
    groups: { [key: string]: number };
    experimentInCurrentLocale: number;
};

export const ExperimentContext = createContext<ContextProps>(
    {} as ContextProps
);

export const useExperimentContext = () => useContext(ExperimentContext);
